import { mapActions, mapGetters } from 'vuex';

export function PetState(storeModule) {
  return {
    data() {
      return {
        pet: {
          petType: null,
          petBreed: null,
          petSex: null,
          petAlias: null,
          petBirthDate: null,
          microchipCode: null,
          microchipDate: null,
        },
      };
    },
    mounted() {
      this.pet = {
        ...this.pet,
        petType: this.getPetType ?? this.pet.petType,
        petBreed: this.getPetBreed ?? this.pet.petBreed,
        petSex: this.getPetSex ?? this.pet.petSex,
        petAlias: this.getPetAlias ?? this.pet.petAlias,
        petBirthDate: this.getPetBirthDate ?? this.pet.petBirthDate,
        microchipCode: this.getMicrochipCode ?? this.pet.microchipCode,
        microchipDate: this.getMicrochipDate ?? this.pet.microchipDate,
      };
    },
    computed: {
      ...mapGetters(storeModule, [
        'getPetType',
        'getPetBreed',
        'getPetSex',
        'getPetAlias',
        'getPetBirthDate',
        'getMicrochipCode',
        'getMicrochipDate',
      ]),
    },
    methods: {
      ...mapActions(storeModule, [
        'setPetType',
        'setPetBreed',
        'setPetSex',
        'setPetAlias',
        'setPetBirthDate',
        'setMicrochipCode',
        'setMicrochipDate',
      ]),
      petClear() {
        this.pet = {
          ...this.pet,
          petType: null,
          petBreed: null,
          petSex: null,
          petAlias: null,
          petBirthDate: null,
          microchipCode: null,
          microchipDate: null,
        };
      },
    },
    watch: {
      'pet.petType'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setPetType(newValue);
        }
      },
      'pet.petBreed'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setPetBreed(newValue);
        }
      },
      'pet.petSex'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setPetSex(newValue);
        }
      },
      'pet.petAlias'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setPetAlias(newValue);
        }
      },
      'pet.petBirthDate'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setPetBirthDate(newValue);
        }
      },
      'pet.microchipCode'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setMicrochipCode(newValue);
        }
      },
      'pet.microchipDate'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setMicrochipDate(newValue);
        }
      },
    },
  };
}